import React, { useContext } from 'react'
import { AuthContext } from '../../../context/authProvider'
import { FormatAmount } from '../../../atomic-components/atoms/formatAmount'
import { StyledAmountWrapper } from './styles'

const Amount = (props) => {
  const { user } = useContext(AuthContext)

  return (
    <StyledAmountWrapper onClick={props.onClick}>
      <FormatAmount
        amount={user?.wallet?.amount}
        shortCode={user?.wallet?.currency?.short_code}
        currencySymbol={user?.wallet?.currency?.symbol}
        maximumFractionDigits={2}
        minimumFractionDigits={2}
      />
    </StyledAmountWrapper>
  )
}

export { Amount }
